import React from 'react';
import { 
  ToggleButtonGroup, 
  ToggleButton, 
  Tooltip 
} from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ArticleIcon from '@mui/icons-material/Article';
import TableChartIcon from '@mui/icons-material/TableChart';
import MenuBookIcon from '@mui/icons-material/MenuBook';

/**
 * Reusable component for selecting different view modes
 * @param {Object} props - Component props
 * @param {string} props.viewMode - Current view mode
 * @param {function} props.handleViewModeChange - Function to handle view mode changes
 * @param {boolean} props.hideShelf - Whether to hide the shelf view option (e.g., for wishlists)
 * @param {Object} props.sx - Additional styling
 * @returns {JSX.Element} View mode selector component
 */
const ViewModeSelector = ({ viewMode, handleViewModeChange, hideShelf = false, sx = {} }) => {
  return (
    <ToggleButtonGroup
      value={viewMode}
      exclusive
      onChange={handleViewModeChange}
      aria-label="view mode"
      size="small"
      sx={{ 
        height: '56px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        ...sx 
      }}
    >
      {!hideShelf && (
        <ToggleButton value="shelf" aria-label="shelf view">
          <Tooltip title="Shelf View">
            <MenuBookIcon />
          </Tooltip>
        </ToggleButton>
      )}
      <ToggleButton value="grid" aria-label="grid view">
        <Tooltip title="Grid View">
          <GridViewIcon />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="list" aria-label="list view">
        <Tooltip title="List View">
          <ViewListIcon />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="large" aria-label="large view">
        <Tooltip title="Large View">
          <ViewModuleIcon />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="detailed" aria-label="detailed view">
        <Tooltip title="Detailed View">
          <ArticleIcon />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="table" aria-label="table view">
        <Tooltip title="Table View">
          <TableChartIcon />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewModeSelector;
